// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".separate[data-v-a6951fb6]{margin-top:70px}@media(max-width:1023px){.LocationTransportAccessibilityBlock2[data-v-a6951fb6]{display:none}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
